<template>
  <div class="our-story">
    <div class="card" :class="{ flipped: flipped }">
      <div class="our-story-image-area card-face card-front">
        <div class="our-story-background" />
        <img class="our-story-image" src="@/assets/our-story.png" />
        <span class="h3 our-wedding">
          The Bardai-Long<br />
          Wedding
        </span>
        <span class="h3 our-date">
          August 2-3rd, 2021<br />
          Canmore, Alberta, Canada
        </span>
      </div>
      <div class="card-face card-back">
        <div class="pics-area">
          <div class="pic-div">
            <img
              class="pics pic1"
              src="@/assets/gallery/farzana-christopher-5.jpg"
            />
          </div>
          <div class="pic-div">
            <img
              class="pics pic2"
              src="@/assets/gallery/farzana-christopher-48.jpg"
            />
          </div>
          <div class="pic-div">
            <img
              class="pics pic3"
              src="@/assets/gallery/farzana-christopher-32.jpg"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <h1 class="h1">
        Our Story
      </h1>
      <p class="p">
        How the C met the F.
      </p>
      <p class="p">
        In 2011, their paths would first cross at the University of Sussex as
        the initial stages of postgraduate study would be completed, yet their
        first meeting would have to wait.
      </p>
      <p class="p">
        Six years later the stars would align, giving them a second chance.
      </p>
      <p class="p">
        In a class to train those seeking to teach, they would lay eyes on each
        other for the first time.
      </p>
      <p class="p">
        The C was captivated by the F’s confidence and erudition on the matters
        of education.
      </p>
      <p class="p">
        Months later, their first encounter would take place over how best to
        build a fire that would one day capture their hearts.
      </p>
      <p class="p">
        F’s adventures to Afghanistan would dampen but not extinguish these
        flames.
      </p>
      <p class="p">
        Embers still burning, the fire would be rekindled nine months later upon
        the F’s return and their chance meeting in the ether of the internet via
        algorithmic providence.
      </p>
      <p class="p">
        Researchers at heart, the C and the F devoured each other’s horoscopes
        in search of astral alignment.
      </p>
      <p class="p">
        The C and the F, naturally familiar with the Pisces man’s love of
        laughter knew that the C’s sensitive and wandering imagination would
        complement the F’s Virgo like attention to detail, care and deep sense
        of humanity.
      </p>
      <p class="p">
        Their astral compatibility assured, the C and the F ventured forth into
        the heady sights of Europe and Asia.
      </p>
      <p class="p">
        Tested through hiking adventures, vehicular mishaps and the intoxicating
        allure of pistachio tiramisu, their bond was forged ever stronger.
      </p>
      <p class="p">
        On to the roaring, foaming waters of Niagara.
      </p>
      <p class="p">
        Under the delightful trickles of falling water, a proposal was made and
        eagerly accepted, much to the relief of the C.
      </p>
      <p class="p">
        And so we found ourselves planning and preparing for our celebration
        with you...
      </p>
      <p class="p">
        As the weeks went by slowly our plans began to come together, hotels and
        flights were booked.
      </p>
      <p class="p">
        Until a time, around new year when microbial mischief began to manifest.
      </p>
      <p class="p">
        First in China then onwards across the globe carrying with it a tsunami
        of fevers and worry for loved ones.
      </p>
      <p class="p">
        So now out of concern for you, our treasured guests we find ourselves
        postponed.
      </p>
      <p class="p">
        Another year during which the C must convince the F to trust in him
        forevermore…
      </p>
      <p class="p">
        Wish him luck
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurStory",
  data() {
    return {
      flipped: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.flip();
    }, 5000);
  },
  methods: {
    flip() {
      this.flipped = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/scss/base.scss";

.our-story {
  display: flex;
  flex-direction: column;
  padding-top: 60px;
}

@media screen and (min-width: $screen-medium) {
  .our-story {
    padding: 0;
  }
}

.our-story-image-area {
  position: relative;
  padding-top: 166px;
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 230px;
}

@media screen and (min-width: $screen-large) {
  .our-story-image-area {
    padding-top: 379px;
  }
}

.our-story-background {
  width: 100%;
  height: 104px;
  position: absolute;
  top: 62px;
  background: #333333;
}

@media screen and (min-width: $screen-large) {
  .our-story-background {
    height: 378px;
  }
}

.our-story-image {
  position: absolute;
  top: -50px;
  width: 250px;
}

@media screen and (min-width: $screen-large) {
  .our-story-image {
    top: -48px;
    width: 566px;
  }
}

.flipped {
  transform: rotateY(180deg);
}

.card {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 1s;
}

.card-face {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: $border-radius;
  backface-visibility: hidden;
}

.card-front {
  transform: rotateY(0deg);
}

.card-back {
  top: 62px;
  right: 0;
  left: 0;
  height: 400px;
  transform: rotateY(180deg);
  justify-content: center;
  align-items: center;
  background: #333333;
}

@media screen and (min-width: $screen-medium) {
  .card-back {
    height: 600px;
  }
}

@media screen and (min-width: $screen-large) {
  .card-back {
    height: 600px;
  }
}

.pics-area {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  max-width: 1220px;
}

.pic2 {
  display: none;
}

.pic3 {
  display: none;
}

@media screen and (min-width: $screen-large) {
  .pic2 {
    display: flex;
  }
}

@media screen and (min-width: $screen-large) {
  .pic3 {
    display: flex;
  }
}

.our-date {
  position: absolute;
  top: 390px;
  width: 100%;
  color: #333;
  text-align: center;
}

@media screen and (min-width: $screen-large) {
  .our-date {
    width: auto;
    top: 214px;
    color: #fff;
    right: 80px;
  }
}

.our-wedding {
  position: absolute;
  top: 300px;
  width: 100%;
  color: #333;
  text-align: center;
}

@media screen and (min-width: $screen-large) {
  .our-wedding {
    width: auto;
    top: 214px;
    color: #fff;
    left: 100px;
  }
}

.page {
  padding-top: 430px;
}

@media screen and (min-width: $screen-medium) {
  .page {
    padding-top: 628px;
  }
}

@media screen and (min-width: $screen-large) {
  .page {
    padding-top: 628px;
  }
}

.h1 {
  font-family: "Parisienne", cursive;
  color: #333333;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 16px;
}

.h2 {
  font-family: "Parisienne", cursive;
  font-size: 28px;
  line-height: 44px;
  font-weight: 800;
  margin-bottom: 16px;
}

.h3 {
  font-family: "Parisienne", cursive;
  font-size: 22px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 16px;
}

.h4 {
  font-family: "Parisienne", cursive;
  font-size: 18px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 16px;
}

.p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  font-family: "Cinzel", serif;
  text-transform: none !important;
}

a {
  color: #333333;
  weight: 800;
}

@font-face {
  font-family: "melinda";
  font-style: normal;
  font-weight: normal;
  src: local("melinda"), url("../assets/melinda-script.ttf") format("truetype");
}

@font-face {
  font-family: "melinda";
  font-style: normal;
  font-weight: normal;
  src: local("melinda"), url("../assets/melinda-script.ttf") format("truetype");
}
</style>
